import PropTypes from "prop-types";

import logoDark from "./logo-dark.png";
import logoDark2 from "./logo-dark@2.png";
import logoDark3 from "./logo-dark@3.png";

import logoDarkMono from "./logo-dark-mono.png";
import logoDarkMono2 from "./logo-dark-mono@2.png";
import logoDarkMono3 from "./logo-dark@3.png";

import logoLight from "./logo-light.png";
import logoLight2 from "./logo-light@2.png";
import logoLight3 from "./logo-light@3.png";

import logoLightMono from "./logo-light-mono.png";
import logoLightMono2 from "./logo-light-mono@2.png";
import logoLightMono3 from "./logo-light-mono@3.png";

const Logo = props => {
  const { mono, dark, width } = props;

  return (
    <>
      {dark ? (
        mono ? (
          <picture>
            <source srcSet={`${logoDarkMono}, ${logoDarkMono2} 2x, ${logoDarkMono3} 3x`} />
            <img src={logoDark} alt="logo" width={width} />
          </picture>
        ) : (
          <picture>
            <source srcSet={`${logoDark}, ${logoDark2} 2x, ${logoDark3} 3x`} />
            <img src={logoDarkMono} alt="logo" width={width} />
          </picture>
        )
      ) : mono ? (
        <picture>
          <source srcSet={`${logoLightMono}, ${logoLightMono2} 2x, ${logoLightMono3} 3x`} />
          <img src={logoLight} alt="logo" width={width} />
        </picture>
      ) : (
        <picture>
          <source srcSet={`${logoLight}, ${logoLight2} 2x, ${logoLight3} 3x`} />
          <img src={logoLight} alt="logo" width={width} />
        </picture>
      )}
    </>
  );
};

Logo.defaultProps = {
  dark: false,
  mono: false,
  width: 320
};

Logo.propTypes = {
  mono: PropTypes.bool,
  dark: PropTypes.bool,
  width: PropTypes.number
};

export default Logo;
